import React from 'react'

export const WarningIcon = () => {
	return (
		<svg height="18" width="18" fill="none" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.9919 0.00156495L9.15231 0C14.0248 0 17.9097 3.88498 17.9958 8.84351C18.0827 13.8036 14.049 17.9116 9.0052 17.9984L8.84636 18C3.97312 18 0.0881441 14.1158 0.00128959 9.15728C-0.039399 6.76135 0.883919 4.48357 2.60536 2.74491C4.31271 1.018 6.58188 0.0438185 8.9919 0.00156495ZM8.60669 4.69481C8.60747 4.47885 8.78275 4.30357 8.99871 4.30357C9.21467 4.30357 9.38994 4.47885 9.38916 4.69481V10.1721C9.38994 10.3881 9.21467 10.5634 8.99871 10.5634C8.78275 10.5634 8.60747 10.3881 8.60669 10.1721V4.69481ZM9.0131 13.6935H8.99901C8.57328 13.6935 8.22346 13.3523 8.21642 12.925C8.20937 12.493 8.55293 12.1362 8.98571 12.1291C8.98816 12.1291 8.99061 12.1289 8.99296 12.1287C8.99426 12.1286 8.99552 12.1285 8.99673 12.1284C8.99751 12.1284 8.99827 12.1284 8.99901 12.1284C9.42552 12.1284 9.77456 12.4696 9.7816 12.8976C9.78943 13.3296 9.44431 13.6857 9.0131 13.6935Z"
				fill="#FEB734"
				fillRule="evenodd"
			/>
		</svg>
	)
}
